import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css'; // O 'quill.snow.css' si prefieres ese estilo base
import '../assets/css/readOnlyContent.css';

const ReadOnlyContent = ({ htmlContent }) => {

    // Configuración para el modo de solo lectura
    const modules = {
        toolbar: false, // Oculta la barra de herramientas
    };

    return (
        <div className='read-only-content'>
        <ReactQuill
            value={htmlContent || ''} // El contenido HTML a mostrar
            readOnly={true}          // Activa el modo de solo lectura
            theme="bubble"           // El tema 'bubble' es ideal para mostrar contenido sin bordes de editor
            modules={modules}        // Aplica la configuración sin toolbar
        />
        </div>
    );
};

export default ReadOnlyContent;